import { FullMethodDispatcher } from "@pdfking/tfunc"

import { ContentType } from "../types/files/ContentType"
import type { VirtualFile } from "../types/files/VirtualFile"
import { VirtualFileType } from "../types/files/VirtualFileType"

export const FileContentType = FullMethodDispatcher<[VirtualFile], ContentType>(
  {
    [VirtualFileType.GENERATED_FILE]: file => file.type,
    [VirtualFileType.REMOTE_FILE]: file => file.type,
    [VirtualFileType.SINGLE_PAGE_IMAGE]: () => ContentType.PNG,
    [VirtualFileType.SINGLE_PAGE_PDF]: () => ContentType.PDF,
    [VirtualFileType.MULTI_PAGE_PDF]: () => ContentType.PDF,
    [VirtualFileType.ZIP_FILE]: () => ContentType.ZIP,
  }
)
